import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-sm border-b border-zinc-800' : 'bg-transparent'
      }`}
    >
      <div className="px-6 py-6">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/45a01c2f2d1de986a5803f825a3dccfb/3a15f933dca46329b0e85fe861d3b2d2.png" 
              alt="Justine Sacco" 
              className="h-12 w-auto object-contain"
            />
          </Link>

          <div className="flex items-center gap-8">
            <Link 
              to="/about" 
              className={`text-base font-semibold tracking-widest transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/about') ? 'text-[#FF4D00]' : 'text-white hover:text-[#FF4D00]'
              }`}
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              ABOUT
            </Link>
            <Link 
              to="/writing" 
              className={`text-base font-semibold tracking-widest transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/writing') ? 'text-[#FF4D00]' : 'text-white hover:text-[#FF4D00]'
              }`}
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              WRITING
            </Link>
            <Link 
              to="/contact" 
              className={`text-base font-semibold tracking-widest transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/contact') ? 'text-[#FF4D00]' : 'text-white hover:text-[#FF4D00]'
              }`}
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              CONTACT
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
